import appApi from '../../../../../../api/app-api';
import { WorkingHoursStatus } from '../../../../../../api/types/lecturers/working-hours/working-hours.type';
import { toast } from 'react-toastify';

export const updateWorkingHoursStatusOperation = async (
  workingHoursId: number,
  workingHoursStatus: WorkingHoursStatus,
) => {
  try {
    await appApi.updateManualWorkingHoursStatus(
      workingHoursId,
      workingHoursStatus,
    );
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
    console.error(
      `updateWorkingHoursStatusOperation is failed with the workingHoursId: ${workingHoursId}, workingHoursStatus: ${workingHoursStatus} and the error: ${e}`,
    );
  }
};
